import DisplayList from './DisplayList';

class ImageGallery {
  constructor(props) {
    this.curImage = props.firstImage || 0;
    this.curSlide = null;
    this.nextSlide = null;
    this.lastSlide = null;

    this.slideEnabled = props.slideEnabled !== false;

    this.shell = props.shell;
    this.shell.style.overflow = 'hidden';
    this.lastBtn = props.lastBtn;
    this.nextBtn = props.nextBtn;

    this.imageList = props.images;
    this.totalImages = this.imageList.length;

    if (this.totalImages === 2) {
      this.imageList = this.imageList.concat(this.imageList);
      this.totalImages = this.imageList.length;
    }

    if (this.slideEnabled) {
      this.initSwipes();
    }
    this.initArrows();
    this.initKeys();
    this.layout();

    this.slides = this.shell.querySelectorAll('.slide');
    this.updateSlides(this.curImage);
  }

  layout() {
    DisplayList.create(
        '<div class="slide not-loaded" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; overflow: hidden;" data-image="{{image}}"><div class="imageShell"  style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; overflow: hidden; background-size: {{scale}}; background-position: center center; background-repeat: no-repeat;"></div></div>',
        this.imageList,
        this.shell
    );
  }

  initKeys() {
    document.addEventListener('keydown', (e) => {
      const key = e.key || e.keyCode;
      switch (key) {
        case 37: // left
          this.gotoImage(-1, 0, -1, !this.slideEnabled);
          return false;
        case 39: // right
          this.gotoImage(1, 0, -1, !this.slideEnabled);
          return false;
      }
    });
  }

  updateSlides(num) {
    this.slides.forEach((slide) => {
      slide.style.display = 'none';
    });
    this.curSlide = this.slides[num];
    this.curSlide.style.left = 0;
    this.curSlide.style.display = 'block';

    this.nextSlide = this.slides[num + 1 >= this.totalImages ? 0 : num + 1];
    this.nextSlide.style.left = '100%';
    this.nextSlide.style.display = 'block';

    this.lastSlide = this.slides[num - 1 < 0 ? this.totalImages - 1 : num - 1];
    this.lastSlide.style.left = '-100%';
    this.lastSlide.style.display = 'block';
    if (this.curSlide.classList.contains('not-loaded')) {
      this.loadImage(this.curSlide);
    }
    if (this.lastSlide.classList.contains('not-loaded')) {
      this.loadImage(this.lastSlide);
    }
    if (this.nextSlide.classList.contains('not-loaded')) {
      this.loadImage(this.nextSlide);
    }
  }

  initArrows() {
    this.lastBtn.addEventListener('click', () => {
      this.gotoImage(-1, 0, -1, !this.slideEnabled);
    });
    this.nextBtn.addEventListener('click', () => {
      this.gotoImage(1, 0, -1, !this.slideEnabled);
    });
  }

  loadImage(slide) {
    slide.classList.add('loading');
    slide.classList.remove('not-loaded');
    const img = new Image();
    img.target = slide;
    img.onload = () => {
      const myTarget = img.target;
      const imgShell = myTarget.querySelector('.imageShell');
      imgShell.style['background-image'] = 'url(' + img.src + ')';
      myTarget.classList.remove('loading');
      myTarget.classList.add('loaded');
    };
    img.src = slide.getAttribute('data-image');
  }

  /* SWIPING MOTION ------------------------- */

  initSwipes() {
    this.xStart = -10;
    this.sliding = false;
    this.shell.addEventListener('mousedown', this.startSwipe.bind(this));
    this.shell.addEventListener('touchstart', this.startSwipe.bind(this));
  }

  startSwipe(e) {
    // e.preventDefault();
    if (this.sliding) {
      return;
    }
    console.log(e);

    this.shell.classList.add('grabbed');
    if (e.type === 'touchstart') {
      if (e.touches.length) {
        if (this.xStart != -10) {
          return;
        }

        const onTouchMove = (e) => {
          this.onMoveUpdate(Math.floor((100 * (e.touches[0].pageX - this.xStart)) / this.shell.clientWidth));
        };

        const onStopSwipeTouch = (e) => {
          console.log('yes');
          e.preventDefault();
          this.shell.classList.remove('grabbed');
          if (e.changedTouches.length > 1) {
            return false;
          }
          document.removeEventListener('touchend', onStopSwipeTouch);
          document.removeEventListener('touchmove', onTouchMove);
          const dist = e.changedTouches[0].pageX - this.xStart;

          const pct = Math.max(
              -1,
              Math.min(1, Number(((e.changedTouches[0].pageX - this.xStart) / this.shell.clientWidth).toFixed(2)))
          );
          if (Math.abs(dist) < 20) {
            this.gotoImage(0, pct, -1, !this.slideEnabled);
          } else {
            const nextLast = e.changedTouches[0].pageX < this.xStart ? 1 : -1;
            this.gotoImage(nextLast, pct, -1, !this.slideEnabled);
          }
          this.xStart = -10;
          return false;
        };

        this.xStart = e.targetTouches[0].pageX;
        document.addEventListener('touchend', onStopSwipeTouch);
        document.addEventListener('touchmove', onTouchMove);
      }
    } else {
      const onMouseMove = (e) => {
        this.onMoveUpdate(Math.floor((100 * (e.pageX - this.xStart)) / this.shell.clientWidth));
        return false;
      };

      const onStopSwipeMouse = (e) => {
        this.shell.classList.remove('grabbed');
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onStopSwipeMouse);
        const dist = e.pageX - this.xStart;

        const pct = Math.max(-1, Math.min(1, Number((dist / this.shell.clientWidth).toFixed(2))));

        if (Math.abs(dist) > 20) {
          const nextLast = e.pageX < this.xStart ? 1 : -1;
          this.gotoImage(nextLast, pct, -1, !this.slideEnabled);
        } else {
          this.gotoImage(0, pct, -1, !this.slideEnabled);
        }

        this.xStart = -10;
        return false;
      };
      this.xStart = e.pageX;
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onStopSwipeMouse);
    }
  }

  onMoveUpdate(dif) {
    const adjDif = Math.max(-100, Math.min(100, dif));
    this.curSlide.style.left = adjDif + '%';
    this.nextSlide.style.left = 100 + adjDif + '%';
    this.lastSlide.style.left = -100 + adjDif + '%';
  }

  gotoImage(dir, pct, forceCurImage, skipTrans) {
    if (this.sliding) {
      return;
    }
    this.sliding = true;
    if (forceCurImage === -1) {
      this.curImage += dir;
      if (this.curImage < 0) {
        this.curImage = this.totalImages - 1;
      } else if (this.curImage >= this.totalImages) {
        this.curImage = 0;
      }
    } else {
      this.curImage = forceCurImage;
    }

    if (dir) {
      this.curSlide.style.left = (100 * -dir) + '%';
      this.nextSlide.style.left = (100 * -dir + 100) + '%';
      this.lastSlide.style.left = (100 * -dir - 100) + '%',
      this.onSlideComplete();
    } else {
      this.onSlideComplete();
      this.curSlide.style.left = 0;
      this.nextSlide.style.left = '100%';
      this.lastSlide.style.left = '-100%';
    }
  }

  jumpToImage(num, skipTrans) {
    if (num == this.curImage) {
      return;
    }
    if (num > this.curImage) {
      this.nextSlide.style.display = 'none';
      this.nextSlide = this.slides[num];
      this.nextSlide.style.left = '100%';
      this.nextSlide.style.display = 'block';
      if (this.nextSlide.classList.contains('not-loaded')) {
        this.loadImage(this.nextSlide);
      }
    } else {
      this.lastSlide.style.display = 'none';
      this.lastSlide = this.slides[num];
      this.lastSlide.style.left = '-100%';
      this.lastSlide.style.display = 'block';
      if (this.lastSlide.classList.contains('not-loaded')) {
        this.loadImage(this.lastSlide);
      }
    }

    this.gotoImage(num > this.curImage ? 1 : -1, 0, num, skipTrans);
  }

  setImage(newImage) {
    this.curImage = newImage;
    this.updateSlides(this.curImage);
    this.curSlide.style.left = 0;
    this.nextSlide.style.left = '100%';
    this.lastSlide.style.left = '-100%';
  }

  onSlideComplete() {
    this.sliding = false;
    this.updateSlides(this.curImage);
  }
}

export default ImageGallery;
